import React, { ReactNode } from "react";
import { VPUITheme } from "../../common/theme/vpui-theme";
import { ThemeProvider, Typography } from "@mui/material";

import "./style.scss";

interface IPageContentProps {
    title: string;
    description: string;
    className?: string;
    children: ReactNode;
}

export const PageContent = (props: IPageContentProps) => {
    return <ThemeProvider theme={VPUITheme}>
        <div className={props.className} style={{
            "--palette-color-primary-light": VPUITheme.palette.primary.light,
            "--palette-color-primary": VPUITheme.palette.primary.main,
            "--palette-color-secondary-light": VPUITheme.palette.secondary.light,
            "--palette-color-secondary": VPUITheme.palette.secondary.main,
            "--palette-color-text": VPUITheme.palette.text.primary,
            "--palette-color-success-light": VPUITheme.palette.success.light,
            "--palette-color-success-dark": VPUITheme.palette.success.dark,
            "--palette-color-success": VPUITheme.palette.success.main,
            "--palette-color-error-light": VPUITheme.palette.error.light,
            "--palette-color-error-dark": VPUITheme.palette.error.dark,
            "--palette-color-error": VPUITheme.palette.error.main,
        } as React.CSSProperties}>
            <div className={"page-header"}>
                <Typography variant={"h3"} color={"textPrimary"} sx={{ fontSize: "32px" }}>{props.title}</Typography>
                <Typography color={"textSecondary"}>{props.description}</Typography>
            </div>
            {props.children}
        </div>
    </ThemeProvider>;
};
